import SurveySubmissionForm from "@agrigate/feed-manager-ui/lib/SurveySubmissionForm";
import LoginGuard from "@agrigate/shared-web-ui/lib/LoginGuard";
import type { ReactElement } from "react";
import { StringParam, useQueryParam } from "use-query-params";

export default function SurveysPage(): ReactElement | null {
    const [id] = useQueryParam("id", StringParam);
    const [localeCode] = useQueryParam("localeCode", StringParam);

    if (!id) return null;

    return (
        <LoginGuard>
            <SurveySubmissionForm
                id={id}
                localeCode={localeCode}
                assetBaseUrl={ASSETS_BUCKET_BASE_URL}
            />
        </LoginGuard>
    );
}
